import Button from '@mui/material/Button/Button';
import styled from 'styled-components';



export const SwitchContainer = styled.div`
  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const SwitchLabel = styled.span<{ activeLabel?: boolean; }>`
  font-size: 0.875rem;
  font-weight: 700;
  color: ${props => props.activeLabel ? "#781AA0" : "#9E9E9E"};
  padding: 0;
  display: flex;
  align-items: center;
`

export const WrapperTotal = styled.div`
  background: white;
  width: 90%;
  margin: auto;
  padding: 32px;
  max-height: 96vh;
  overflow-y: auto;
  max-width: 700px;
  position: relative;
  border-radius: 8px;

  > button {
    position: absolute;
    right: 32px;
    background: none;
    border: 0;
    font-size: 1.25rem;
    height: 20px;
    font-weight: 700;
    cursor: pointer;
    color: #616161;
  }
`

export const Title = styled.h3`
  text-align: center;
  font-weight: 500;
  font-size: 1.625rem;
  color: #641585;
  margin-bottom: 32px;
  margin-top: 16px;
`

export const BoxAvatarAndName = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const BoxFields = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: 800px) {
    flex-direction: column;
    align-items: unset;
  }

  > div {
    flex: 1;
  }
`

export const BoxButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledLabel = styled.label`
  color: #212121;
  display: inline-block;
  font-weight: 500;
  font-size: 1.25rem;
  margin-bottom: 16px;
`

export const CancelButton = styled(Button)`
  background-color: #C62828 !important;
  color: white !important;
  text-transform: capitalize !important;

  &:hover {
    filter: brightness(0.9)
  }
`;

export const PrimaryButton = styled(CancelButton)`
  background-color: #036CBF !important;

  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.7;
  }
`;

export const OutlineButton = styled(Button)`
  background-color: white !important;
  color: #C62828 !important;
  border: 1px solid #C62828 !important;
  text-transform: capitalize !important;

  &:hover {
    background-color: #C62828 !important;
    color: white !important;
  }
`;


export const MsgError = styled.p`
    color: #d32f2f;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    text-align: center;
    margin-top: 3px;
    margin-bottom: 0;
`


